/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { TextInput, composeValidators, Checkbox } from '@blend/enterprise-components';
import { WrappedInput } from 'blb-components/WrappedInput';
import { requiredEmailValidator, emptyPasswordValidator, strengthAndMatchValidator, emptyCheckboxValidator } from 'blb-utils/validators';
import { getPasswordInputConfig } from 'blb-utils/inputs';
const styles = StyleSheet.create({
  fieldWrapper: {
    ':not(:last-child)': {
      marginBottom: 24
    }
  },
  footerComponentWrapper: {
    flex: '1'
  }
});
export const usernameInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'text'
  },
  inputComponent: TextInput,
  label: 'Email',
  labelSize: 'sm',
  name: 'username',
  validate: requiredEmailValidator
};
export const passwordInputConfig = getPasswordInputConfig();
export const passwordInputConfigWithValidation = getPasswordInputConfig({
  name: 'newPassword',
  validate: composeValidators(emptyPasswordValidator, strengthAndMatchValidator)
});
export const confirmPasswordInputConfig = getPasswordInputConfig({
  label: 'Confirm Password',
  name: 'confirmedPassword'
});
export const rememberMeInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.footerComponentWrapper],
  customComponentProps: {},
  defaultValue: 'true',
  displayAdditionalMessagingInContainer: false,
  infoTooltip: 'If checked, on successful login you will not be asked to perform MFA for next 30 days',
  inputComponent: Checkbox,
  label: 'Remember my MFA for 30 days',
  labelPosition: 'right',
  labelSize: 'sm',
  name: 'rememberMe',
  type: 'checkbox'
};
export const confirmPhoneNumberInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.footerComponentWrapper],
  customComponentProps: {},
  displayAdditionalMessagingInContainer: false,
  inputComponent: Checkbox,
  label: 'I confirm this is a mobile phone number',
  labelPosition: 'right',
  labelSize: 'sm',
  name: 'confirmPhoneNumber',
  type: 'checkbox',
  validate: composeValidators(emptyCheckboxValidator)
};